import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b33f2fbc&lang=pug"
import script from "./script.ts?vue&type=script&lang=js&external"
export * from "./script.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports